/** Merge saved order with current default ids (keeps unknowns out, appends new ids). */
export function mergeOrder(saved, defaults) {
  const known = new Set(defaults);
  const ordered = (Array.isArray(saved) ? saved : []).filter((id) => known.has(id));
  defaults.forEach((id) => {
    if (!ordered.includes(id)) ordered.push(id);
  });
  return ordered;
}

/** Move `fromId` to the position of `toId` within an ordered id list. */
export function reorderIds(list, fromId, toId) {
  if (!fromId || !toId || fromId === toId) return list;
  const next = [...list];
  const from = next.indexOf(fromId);
  const to = next.indexOf(toId);
  if (from < 0 || to < 0) return list;
  next.splice(from, 1);
  next.splice(to, 0, fromId);
  return next;
}

export function dragHandlers(id, { onReorder, setDraggingId }) {
  return {
    draggable: true,
    onDragStart: (e) => {
      e.dataTransfer.setData('text/plain', id);
      e.dataTransfer.effectAllowed = 'move';
      setDraggingId?.(id);
    },
    onDragEnd: () => setDraggingId?.(null),
    onDragOver: (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
    },
    onDrop: (e) => {
      e.preventDefault();
      e.stopPropagation();
      const fromId = e.dataTransfer.getData('text/plain');
      if (fromId && fromId !== id) onReorder(fromId, id);
      setDraggingId?.(null);
    },
  };
}
